'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _video = require('video.js');

var _video2 = _interopRequireDefault(_video);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _pick2 = require('lodash/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _last = require('lodash/last');

var _last2 = _interopRequireDefault(_last);

var _lodash = require('lodash');

var _DebugManager = require('../utils/DebugManager');

var _DebugManager2 = _interopRequireDefault(_DebugManager);

var _utility = require('./utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// videoLibrary can be overriden with a custom JS video library, if desired
// this also makes testing/mocking easier:

var RampVideoPlayer = function RampVideoPlayer(videoId, config) {
  var videoLibrary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _video2.default;
  var dmInstance = _DebugManager2.default.dmInstance;

  var debug = dmInstance.debug.includes(_DebugManager2.default.debugLevel.M);
  var verbose = false;

  var url = window.location.href;
  var queryString = (0, _last2.default)(url.split('?'));

  var _pick = (0, _pick3.default)(_qs2.default.parse(queryString), 'mAddr'),
      mAddr = _pick.mAddr;

  var player = void 0;

  if (debug) {
    dmInstance.logMessage([_DebugManager2.default.debugLevel.M], '[RampVideoPlayer] config: ', config);
    dmInstance.logMessage([_DebugManager2.default.debugLevel.M], '[RampVideoPlayer] using multicast address: ', mAddr || config.mAddr);
    dmInstance.logMessage([_DebugManager2.default.debugLevel.M], '[RampVideoPlayer] fallback url: ', config.fallbackUrls[0]);
    verbose = true;
  }

  window.videojs = _video2.default;
  dmInstance.log('[RampVideoPlayer] videojs version: ', _video2.default.VERSION);

  var playerPromise = new Promise(function (resolve) {
    var load = function load() {
      player = videoLibrary(videoId, _extends({}, config, {
        plugins: {
          multicast: {
            overlay: false,
            verbose: verbose,
            params: {
              maddr: mAddr || config.mAddr,
              streamKey: true,
              allowFallback: true,
              fallbackUrl: (0, _utility.appendURLParams)(config.fallbackUrls[0].src, config.params)
            }
          }
        }
      }));
      (0, _utility.setupHooks)(player, config);
      var urls = config.urls;

      setSourceList(urls);
      resolve(player);
    };
    // eslint-disable-next-line no-new, no-underscore-dangle
    new window._Loader(load, [{
      field: 'ramp-ecdn-plugin-videojs',
      src: '//livetools.rampecdn.com/plugin/alpha/ramp-ecdn-plugin-videojs.js',
      kind: 'js',
      alternate: '//livetools.rampecdn.com/plugin/alpha/ramp-ecdn-plugin-videojs.js'
    }]);
  });

  function setSourceList(urls) {
    if (!Array.isArray(urls) || (0, _lodash.isEmpty)(urls)) {
      console.warn('[RampVideoPlayer] Invalid URLs supplied to the video player.');
      return false;
    }
    var urlList = (0, _utility.processUrls)(urls, config);
    player.src(urlList);
    dmInstance.logMessage([_DebugManager2.default.debugLevel.M], '[RampVideoPlayer] source urls: ', urls);
    return true;
  }

  return playerPromise;
};

exports.default = RampVideoPlayer;